"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var supportsPassive = (function () {
    // simular to jQuery's test
    var supported = false;
    try {
        addEventListener('test', function () { }, Object.defineProperty({}, 'passive', {
            get: function () {
                supported = true;
                return true;
            },
        }));
    }
    catch (e) {
        // do nothing
    }
    return supported;
})();
exports.default = supportsPassive;
